export default __webpack_public_path__ + "static/media/img-cepparo.8f44d62f.svg";